<template>
  <div v-if="containQueue > 0">
    <!-- <div class="fixed top-0 left-0 w-full h-full bg-black opacity-25" style="z-index: 9999"></div> -->
    <div class="bg-white p-2 shadow-md rounded-md text-black mx-4 relative mb-4" style="z-index: 10000">
      <div>
        <van-button
          size="small"
          type="info"
          loading-type="spinner"
          @click="offlineSync"
          :loading="isLoading"
          loading-text="Tunggu sebentar..."
          round
          class="whitespace-nowrap text-md mt-1 float-right"
        >
          <v-icon icon="material-symbols:sync" class="text-xl mr-1 inline" />
          <span class="ml-1 font-bold relative top-[1px]">Synchronize</span>
        </van-button>

        <h3 class="font-semibold text-lg">Kamu mempunyai data offline</h3>
        <div>
          <p class="text-sm">Kamu mempunyai {{ containQueue }} data offline</p>
          <a class="text-sm text-danger underline">Hapus Data</a>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .animate_warning {
    animation: warning 1s infinite step-start;
  }

  @keyframes warning {
    0% {
      background-color: #f6f6f6;
    }
    50% {
      background-color: #ff0000;
      color: #fff;
      /* transform: scale(1.5); */
    }
    100% {
      background-color: #f6f6f6;
    }
  }
</style>

<script>
  import local, { attendanceList, isLoading } from "@/states/local";

  export default {
    data() {
      return { attendanceList, dataQueue: local.dataQueue, isLoading };
    },
    methods: {
      offlineSync() {
        local.uploadQueue();
      }
    },
    computed: {
      containQueue() {
        return this.dataQueue.length;
      }
    }
  };
</script>
